(function(){
    'use strict';

    angular
       .module('appback')
       .factory('DocumentacionService', DocumentacionService);

   DocumentacionService.$inject = ['$http'];

   function DocumentacionService($http){


       var service= {
        saveDocumento: saveDocumento
       };

       return service;

        function saveDocumento(data, documento)
       {
           var config = {
               headers : {
                   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
               }
           }

           var data = $.param({
            fileName: documento.nombre_generado,
            filePath: documento.ruta,
            file_id: documento.file_id,
            tipodocumento_id: data.tipodocumento_id,
            descripcion: data.descripcion,
            visible_intranet: data.visible_intranet
           });
           return $http.post('/backend/documentacion/savedocumento', data, config)
       }

   }
})();